import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/card-group.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/card-group.css');

export const CardGroupDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      Now let&rsquo;s say we want to group a bunch of cards into a single Card
      Group component. There are two tricky requirements to consider here:
    </p>

    <ol>
      <li>
        We want each card to have equal width, even if one card contains more
        content than another card.
      </li>
      <li>
        We want the height of all the card descriptions to be equal. Again, this
        should hold true even if one card&rsquo;s description is longer than
        another card.
      </li>
    </ol>

    <p>
      Without flexbox, you would probably have to resort to using a
      <code>table</code> element to meet these requirements. Or possibly you
      could absolutely position all of the elements and use a combination of
      percentage-based dimensions, pixel-based dimensions, and the{' '}
      <code>calc</code> function. That sounds pretty complex!
    </p>

    <p>
      With flexbox, the solution becomes a bit more elegant, but it does require
      us to use a new flexbox property. Unlike the ones we&rsquo;ve used so far,
      this property is applied to the <strong>children</strong>, not the
      container.
    </p>

    <p>
      We&rsquo;ll set <code>flex: 1 1 0%</code> on each card, to make their
      widths equal within the container. This property is a short-hand for
      setting three specific flexbox properties:
    </p>
  </DemoPage>
);

CardGroupDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/CardGroupDemo.js